import React from 'react';
import { ImageList, ImageListItem, Typography, useMediaQuery, useTheme, Box } from '@mui/material';
import HandoutImageLoader from './handout-image-loader';

function IconStripDesktop({ iconDetails, imageStore }) {
  return (
    <ImageList cols={iconDetails.length} rowHeight="auto" gap={4} className="icon-strip-desktop">
      {iconDetails.map((icon) => (
        <ImageListItem key={icon.img}>
          <Box display="flex" justifyContent="center" width="100%">
            <HandoutImageLoader 
              src={icon.img} 
              alt={icon.alt} 
              imageStore={imageStore}
              style={{ width: '100%', height: 'auto' }} 
            />
          </Box>
          <Typography textAlign="center" mt={1}>{icon.caption}</Typography>
        </ImageListItem>
      ))}
    </ImageList>
  );
}

function IconStripMobileTablet({ iconDetails, imageStore }) {
  const iconHeight = '160px'; // Assuming '160px' is a good height for the icons on tablets

  return (
    <ImageList cols={1} rowHeight='auto' gap={8}> {/* Increased gap for better spacing */}
      {iconDetails.map((icon, index) => (
        <ImageListItem key={icon.img} style={{ height: 'auto', marginBottom: 24 }}> {/* Added marginBottom for spacing */}
          <Box display="flex" justifyContent="center" alignItems="center" width="100%" height={iconHeight}>
            <HandoutImageLoader
              src={icon.img}
              alt={icon.alt}
              imageStore={imageStore}
              style={{ width: '60%', height: '100%', objectFit: 'contain' }}
            />
          </Box>
          <Typography textAlign="center" mt={2}>
            {icon.caption}
          </Typography>
        </ImageListItem>
      ))}
    </ImageList>
  );
}

function IconStrip({ iconDetails, imageStore}) {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const queryParams = new URLSearchParams(window.location.search);
  const isPdfRequested = queryParams.has('pdf');  // Adjust the media query or remove it based on pdfRequested

  const isDesktop = isPdfRequested || !isMobileOrTablet

  return isDesktop 
    ? <IconStripDesktop iconDetails={iconDetails} imageStore={imageStore} />
    : <IconStripMobileTablet iconDetails={iconDetails} imageStore={imageStore} />;
}

export default IconStrip;
